import { useContext } from 'react';
import { TabViewSkeleton } from '@/components/TabView';
import { FolderLoadingContext } from '@/containers/Workspace.Folder/Context';
import { WorkspaceFolderContainer } from '@/containers/Workspace.Folder/Folder.Container';
import styles from '@/screens/Workspace.FilesTable/style/Files.Table.module.css';
import { TagGeneratingFilesProvider } from '@/screens/Workspace.FilesTable/TagGeneratingFilesProvider';
import { FolderTabViewContainer } from './Folder.TabView.Container';
import { Header } from './Header';

type Props = unknown;

const FolderTabs = (props: Props) => {

  const isLoading = useContext(FolderLoadingContext);

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <Header />
        {isLoading
          ? <TabViewSkeleton />
          : <FolderTabViewContainer />}
      </div>
    </div>
  );
};

export const WithState = () => {
  return (
    <TagGeneratingFilesProvider>
      <WorkspaceFolderContainer>
        <FolderTabs />
      </WorkspaceFolderContainer>
    </TagGeneratingFilesProvider>
  );
};

export { WithState as WorkspaceFolder };